import { DEFAULT_VAT_RATE } from '../../atoms/vat-rate/vat-rate.atom';
import { VatRate } from '../../domain/VatRate';

export const getVatRate = (
  vatRates: VatRate[],
  country: string | undefined,
  isCompany?: boolean,
): VatRate => {
  const foundVatRate = vatRates?.find((vatRate) => vatRate.country === country);

  const SALE_COUNTRY = 'LT';

  if ((isCompany && country !== SALE_COUNTRY) || !foundVatRate) {
    return { country: country ?? DEFAULT_VAT_RATE.country, rate: 0 };
  }

  return (
    vatRates?.find((vatRate) => vatRate.country === country) ?? DEFAULT_VAT_RATE
  );
};

export const calculatePriceWithVat = (
  price: number,
  currentVatRate: VatRate | null,
): number => {
  const rate = currentVatRate ? currentVatRate.rate : DEFAULT_VAT_RATE.rate;
  const vatAmount = price * (rate / 100);

  return price + vatAmount;
};
